<template>
  <div class="p-multi-column">
    <div
      class="p-multi-column__row"
      v-for="(row, index) in data"
      :key="index"
      :style="getStyle"
      :class="{'row-padding': index > 0}"
    >
      <template v-for="(item, index) in row" :key="`item-${index}`">
        <div class="p-multi-column__item" v-if="!item.isHidden">
          <div class="p-multi-column__title" :title="item.title">
            {{ item.title }}
          </div>
          <div class="p-multi-column__value" :title="item.value">
            <span class="p-multi-column__value-plan">{{ item.value }}</span>
            <span v-if="item.fact" class="p-multi-column__value-fact">{{ item.fact }}</span>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import {
  ProSpaceHLayout,
  ProSpaceVLayout,
  ProSpaceTag
} from "@prospace/prospace-components-library";
export default {
  name: "multiColumn",
  components: {
    ProSpaceHLayout,
    ProSpaceVLayout,
    ProSpaceTag
  },
  props: {
    data: {
      type: Object
    },
    columns: {
      type: Number
    }
  },
  computed: {
    getStyle() {
      const count = this.getMaxColumnCount === 1 ? 1 : this.columns;
      return `grid-template-columns: repeat(${count}, minmax(56px, calc(100% / ${count})))`
    },
    getMaxColumnCount() {
      let counts = [];
      const defaultCount = 6;
      this.data?.length > 0
        ? this.data.forEach(arr => {
            const countedArr = arr.filter(el => !el.isHidden);
            counts.push(countedArr.length);
          })
        : '';
      const columns = Math.max(...counts);
      return  columns ?? defaultCount;
    }
  }
}
</script>
<style lang="scss" scoped>
.p-multi-column {
  display: grid;
  grid-template-rows: 1fr;
  //border-left: 1px solid #E0E7F4;
  //border-right: 1px solid #E0E7F4;
  .row-padding {
    padding-top: 10px;
  }
  &__row {
    display: grid;
    gap: 10px;
    grid-template-columns: repeat(6, minmax(56px, 87px));
    padding: 10px;
    height: 56px;
    &:not(:last-child) {
      border-bottom: 1px dashed var(--prospace-ui-border-color);
      padding-bottom: 10px;
    }
  }
  &__item {
    display: flex;
    flex-direction: column;
    max-width: 76px;
  }
  &__title {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  &__value-plan {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: break-spaces;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  &__title {
    color: var(--prospace-text-gray);
    font-weight: 500;
    font-size: 10px;
    line-height: 12px;
  }
  &__value {
    display: flex;
    flex-direction: column;
    height: auto;
    line-height: 11px;
    max-height: 24px;
    gap: 2px;
    font-size: 9px;
    margin-top: 3px;
    overflow: visible;
    &-plan {
      color: var(--prospace-text-gray);
    }
    &-fact {
      color: var(--prospace-chart-fact);
    }
  }
}
</style>
